import React, { useState } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    Button, Typography, Box, Avatar, Chip, Divider, Stack, IconButton 
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUser, faClock, faCheck, faBan, faWalking } from '@fortawesome/free-solid-svg-icons';
import { updateBookingStatus } from '../../../controllers/company/MerchantBookingController';

export default function BookingDetailModal({ event, open, onClose, onRefresh }) {
    
    const props = event.extendedProps;
    const [loading, setLoading] = useState(false);

    // Función para cambiar estatus


    const handleChangeStatus = async (result, error) => {
      
        const uuid = props.raw_id || event.id;
        
        try{
            const status = 'completed';
            const response = await updateBookingStatus(uuid,status);
            if(response.success === true){
                alert("✅ Check-in Exitoso");
                onRefresh(); // Recarga el dashboard
                onClose();
            }
            else{
                alert("❌ Error: No se pudo cambiar el estatus.");
                console.error("❌ Error cambiando estatus", error);
            }
            
        }catch(error){
            alert("❌ Error (Bloque Catch): No se pudo cambiar el estatus.");
            console.error("❌ Error cambiando estatus", error);
        }
        finally{
            setLoading(false);
        }
    };

    if (!event) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <Box display="flex" justifyContent="space-between" alignItems="center" p={2} pb={0}>
                <Chip label={props.status_label} color={props.status === 'confirmed' ? 'success' : 'warning'} size="small" />
                <IconButton onClick={onClose} size="small"><FontAwesomeIcon icon={faTimes} /></IconButton>
            </Box>

            <DialogContent sx={{ textAlign: 'center', pt: 2 }}>
                <Avatar src={props.client_avatar} sx={{ width: 80, height: 80, mx: 'auto', mb: 2, bgcolor: 'primary.main' }}>
                    {props.client_name?.charAt(0)}
                </Avatar>
                
                <Typography variant="h6" fontWeight="bold">{props.client_name}</Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>Cliente</Typography>

                <Box sx={{ bgcolor: 'grey.50', p: 2, borderRadius: 2, mt: 2, textAlign: 'left' }}>
                    <Typography variant="subtitle2" fontWeight="bold" gutterBottom>{props.service_name}</Typography>
                    
                    <Stack direction="row" alignItems="center" spacing={1} mt={1}>
                        <FontAwesomeIcon icon={faClock} color="#666" />
                        <Typography variant="body2">
                            {event.start?.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})} - 
                            {event.end?.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                        </Typography>
                    </Stack>
                    
                    {props.notes && (
                        <Typography variant="caption" display="block" mt={1} sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                            Nota: {props.notes}
                        </Typography>
                    )}
                </Box>
            </DialogContent>

            <DialogActions sx={{ p: 2, flexDirection: 'column', gap: 1 }}>
                {props.status === 'pending' && (
                    <Button fullWidth variant="contained" color="success" onClick={() => handleChangeStatus('confirmed')} disabled={loading} startIcon={<FontAwesomeIcon icon={faCheck}/>}>
                        Aceptar Reserva
                    </Button>
                )}

                {props.status === 'confirmed' && (
                    <Stack direction="row" spacing={1} width="100%">
                        <Button fullWidth variant="contained" color="primary" onClick={() => handleChangeStatus('completed')} disabled={loading} startIcon={<FontAwesomeIcon icon={faWalking}/>}>
                            Check-in / Completar
                        </Button>
                    </Stack>
                )}
                
                {(props.status === 'pending' || props.status === 'confirmed') && (
                     <Button fullWidth variant="outlined" color="error" onClick={() => handleChangeStatus('cancelled')} disabled={loading} startIcon={<FontAwesomeIcon icon={faBan}/>}>
                        Cancelar Cita
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}